import type {
	OptionExternalData,
	SecurityLevelOption,
	JiraSecurityLevelFieldInput,
} from './types.tsx';

export const transformOnSubmit = (option: SecurityLevelOption): OptionExternalData => {
	const { label, value } = option;
	return {
		name: label,
		id: value,
	};
};

export const mapOptionsToData = (options: OptionExternalData[]): SecurityLevelOption[] =>
	options.map(({ name, id, description }) => ({
		label: name,
		value: id,
		description,
	}));

export const mapOptionToData = (option: OptionExternalData): SecurityLevelOption | null => {
	if (option) {
		const { name, id, description } = option;
		return {
			label: name,
			value: id,
			description,
		};
	}
	return null;
};

export const mutateSecurityLevelField = (
	selectedSecurityLevel: SecurityLevelOption,
): JiraSecurityLevelFieldInput => ({
	security: {
		securityLevelId: selectedSecurityLevel.value,
	},
});
